import { render, staticRenderFns } from "./EipRoleSelector.vue?vue&type=template&id=4aef45ed&"
import script from "./EipRoleSelector.vue?vue&type=script&lang=js&"
export * from "./EipRoleSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports